import { render, staticRenderFns } from "./rapidProcure.vue?vue&type=template&id=d28927aa&scoped=true"
import script from "./rapidProcure.vue?vue&type=script&lang=js"
export * from "./rapidProcure.vue?vue&type=script&lang=js"
import style0 from "./rapidProcure.vue?vue&type=style&index=0&id=d28927aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28927aa",
  null
  
)

export default component.exports